/**
 * Card — superficie standard DietaGest.
 *
 * Token (design.md §3.5 + §3.6):
 * - background: surface-container-lowest (#FFFFFF)
 * - radius: xl (12px)
 * - shadow: leggera (shadow-sm)
 * - padding: 16px mobile / 24px desktop (md:)
 *
 * Per varianti senza padding (es. card con header sticky proprio),
 * passare `padded={false}` e gestire i padding internamente.
 */

import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { clsx } from 'clsx';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
  /** Aggiunge bordo sottile (default true). Le card embedded in form senza bordo: false. */
  bordered?: boolean;
  children?: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { padded = true, bordered = true, className, children, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      className={clsx(
        'bg-white rounded-xl shadow-sm',
        bordered && 'border border-border-gray/60',
        padded && 'p-4 md:p-6',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
});
